// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-question-group .lsn-question-group-header {
  margin-bottom: 1rem !important;
}
.lsn-question-group .divider {
  margin-block: 1.6rem !important;
  border-color: var(--main-border-color);
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/QuestionBlock/QuestionBlock.less"],"names":[],"mappings":"AAAA;EAEI,8BAAA;AAAJ;AAFA;EAUI,+BAAA;EACA,sCAAA;AALJ","sourcesContent":[".lsn-question-group {\n  .lsn-question-group-header {\n    margin-bottom: 1rem !important;\n\n    // .lsn-text-body {\n    //   margin-top: .2rem;\n    // }\n  }\n\n  .divider {\n    margin-block: 1.6rem !important;\n    border-color: var(--main-border-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
